__webpack_require__.p = "/miadtech/";